__turbopack_context__.v({
  "CancelButton": "tqDMbG_CancelButton",
  "Footer": "tqDMbG_Footer",
  "Footer--Centered": "tqDMbG_Footer--Centered",
  "ModalContent": "tqDMbG_ModalContent",
  "ModalContent--Success": "tqDMbG_ModalContent--Success",
  "ModalWrapper": "tqDMbG_ModalWrapper",
  "Spinner": "tqDMbG_Spinner",
  "StatusText": "tqDMbG_StatusText",
  "SuccessIcon": "tqDMbG_SuccessIcon",
  "SuccessMessage": "tqDMbG_SuccessMessage",
  "skeleton-loading": "tqDMbG_skeleton-loading",
  "spin": "tqDMbG_spin",
});
